export default class MobileViewPopup {

	constructor(onExit, config) {
		this.onExit = onExit;
		this.config = config;
	}

	checkPopup = () => {
		if (this.popup.closed) {
			clearInterval(this.popupTimer);
			this.exitPopup();
		}
	};

	exitPopup = () => {
		$('.dpit-mobile-view-popup__overlay').fadeOut(1000);
		if (this.onExit) this.onExit();
	};

	onOverlayClick = () => {
		if (this.onExit) this.onExit(true);
		$('.dpit-mobile-view-popup__overlay').fadeOut(700);
		clearInterval(this.popupTimer);
		this.popup.close();
	};

	addOverlay = () => {
		if (!$('.dpit-mobile-view-popup__overlay').length) $('body').append('<div class="dpit-mobile-view-popup__overlay"/>');
		$('.dpit-mobile-view-popup__overlay').fadeIn(700);
	};

	popupCenter = (url, title, w, h) => {
		this.addOverlay();
		$('.dpit-mobile-view-popup__overlay').on('click', this.onOverlayClick);

		// Fixes dual-screen position                             Most browsers      Firefox
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		this.popup = window.open(url, title,
			`
          modal=yes,
          resizable=no,
          scrollbars=yes,
          width=${w / systemZoom}, 
          height=${h / systemZoom}
          `
		);
		if (this.popup) {
			this.popup.moveTo(left, top);
			if (window.focus) this.popup.focus();
			this.popupTimer = setInterval(this.checkPopup, 500);
			this.checkPopup();
		}
		else {
			alert(this.config.i18n.allow_popup_to_set_mob);
			this.exitPopup();
		}
		return this.popup;
	};


}